// TopModele.jsx
import React from "react";
import "./topModele.scss";
import { 
  Image, 
  Empty, 
  Tag, 
  Tooltip, 
  Progress,
  Card,
  Space
} from 'antd';
import {
  TrophyOutlined,
  ShoppingOutlined,
  BoxPlotOutlined,
  CheckCircleOutlined
} from '@ant-design/icons';
import config from "../../../../config";

const TopModele = ({ tops }) => {
  const modeles = Array.isArray(tops) && tops.length > 0 ? tops : [];
  const DOMAIN = config.REACT_APP_SERVER_DOMAIN;

  const getRankLabel = (index) => {
    const ranks = ['1er', '2ème', '3ème', '4ème', '5ème'];
    return ranks[index] || `${index + 1}ème`;
  };

  // Nettoyer l'URL de l'image
  const getImageUrl = (img) => {
    if (!img) return null;
    if (img.startsWith('http://') || img.startsWith('https://')) {
      return img;
    }
    return `${DOMAIN}${img}`;
  };

  if (modeles.length === 0) {
    return (
      <Card className="topModele" bordered={false}>
        <div className="topModele_header">
          <Space>
            <TrophyOutlined style={{ fontSize: 18, color: '#1a1a1a' }} />
            <h3>Top modèles par écoulement</h3>
          </Space>
        </div>
        <Empty 
          description="Aucune donnée disponible"
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          style={{ padding: '30px 0' }}
        />
      </Card>
    );
  }

  return (
    <Card className="topModele" bordered={false}>
      <div className="topModele_header">
        <Space>
          <TrophyOutlined style={{ fontSize: 18, color: '#1a1a1a' }} />
          <h3>Top modèles par écoulement</h3>
        </Space>
        <Tag color="default">Top 5</Tag>
      </div>

      <div className="topModele_body">
        {modeles.map((item, index) => {
          const imageUrl = getImageUrl(item.img);
          
          return (
            <div key={index} className="modele_item">
              {/* Rang */}
              <div className="modele_rank">
                <span className="rank_number">{getRankLabel(index)}</span>
              </div>

              {/* Image */}
              <div className="modele_image">
                {imageUrl ? (
                  <Image
                    src={imageUrl}
                    alt={item.nom}
                    width={44}
                    height={44}
                    preview={false}
                    fallback={`${DOMAIN}/images/default-product.png`}
                  />
                ) : (
                  <div className="modele_image_placeholder">
                    <ShoppingOutlined />
                  </div>
                )}
              </div>

              {/* Informations */}
              <div className="modele_info">
                <div className="modele_info_row">
                  <Tooltip title={item.nom}>
                    <span className="modele_nom">{item.nom}</span>
                  </Tooltip>
                  <Tag className="modele_marque">{item.marque || 'Marque'}</Tag>
                </div>
                
                <div className="modele_info_row stats">
                <span>
                    <BoxPlotOutlined /> {item.stock_total || 0} en stock
                </span>
                <span>
                    <CheckCircleOutlined /> {item.vendu_total || 0} vendus
                </span>
                {item.quantite_recue !== undefined && (
                    <span>
                    <ShoppingOutlined /> {item.quantite_recue} reçus
                    </span>
                )}
                </div>
              </div>

              {/* Progression */}
              <div className="modele_progress">
                <div className="modele_progress_header">
                  <span className="modele_progress_label">Écoulement</span>
                  <span className="modele_progress_value">{item.taux}%</span>
                </div>
                <Progress
                  percent={Math.min(item.taux, 100)}
                  showInfo={false}
                  strokeWidth={5}
                  strokeColor="#1890ff"
                  trailColor="#e8e8e8"
                  className="modele_progress_bar"
                />
              </div>
            </div>
          );
        })}
      </div>
    </Card>
  );
};

export default TopModele;